module.exports = __webpack_public_path__ + "media/images/donation-popup-img-789717ffb02b7b781712c7588f0ee10c.png";